export const rnd = (a: number, b: number): number => a + Math.random() * (b - a);
export const rndI = (a: number, b: number): number => Math.floor(rnd(a, b + 1));
export const clamp = (v: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, v));
export const dist = (a: { x: number; y: number }, b: { x: number; y: number }): number =>
  Math.hypot(a.x - b.x, a.y - b.y);
export const ang = (a: { x: number; y: number }, b: { x: number; y: number }): number =>
  Math.atan2(b.y - a.y, b.x - a.x);
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export function lerpAng(a: number, b: number, t: number): number {
  let d = b - a;
  while (d > Math.PI) d -= Math.PI * 2;
  while (d < -Math.PI) d += Math.PI * 2;
  return a + d * t;
}
